import { createContext, useContext } from 'react';

const ComponentDisplayContext = /*#__PURE__*/createContext("standalone");
function useComponentDisplayContext() {
  return useContext(ComponentDisplayContext);
}

export { ComponentDisplayContext, useComponentDisplayContext };
//# sourceMappingURL=context.display-context.js.map
